import axios from 'axios';
import { AppSettings,Storage } from '../../configs';
import { authHeader } from '../../helpers/auth-header';

import {
  START_LOADING,
  STOP_LOADING,
  LOGIN_START,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  SET_USER_DATA,
  // UPDATE_USER_DATA,
  UPDATE_USER_MODAL,
  SET_USER_FAIL,
  GET_ALL_USER,
  ERROR_401,
  ERROR_USER_FAIL
  // GET_BUS_PLACE
} from "./actionTypes";

export function startLoginAction() {
  Storage.clear()

  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })

    dispatch({
      type: LOGIN_START
    })
  }
}

export function getDefaultBusinessPlaceAction(unit_code) {
  return function (dispatch) {
    let promise = axios({
      headers: authHeader(),
      method: "get",
      url: `${AppSettings.apiUrl}/api/RRS/GetUnit_BusinessPlace`,
      params: {
        unit_code: unit_code
      }
    })

    promise.then(response => {
      let unitCode = response.data.unit_Code
      let busPlace= response.data.business_Place_Default

      Storage.setUserBussinessPlace(unitCode,busPlace)
    }
    );

    return promise
  }
}

export function loginAction(username, password ) { 
  return function (dispatch) {

     let promise=  axios({
        method: "post",
        url: `${AppSettings.apiUrl}/api/User/Login`,
        timeout: 60 * 3 * 1000,
        data: {
          username: username,
          password: password
        }
      })
      
      promise.then(response => {
        const success=response.data.success
        const user=response.data.user
        const employee=response.data.employee
        const role=employee?employee.role: "C"

        dispatch({
          type: STOP_LOADING
        })

        dispatch({
          type: LOGIN_SUCCESS
        })

        if (success) {
          Storage.setUser(user)
          Storage.setRole(role)
          Storage.setEmployeePIS(employee)
          Storage.setDatelocalStorage()
          Storage.setAppReadonly(response.data.readonly)
        }
      }
      ).catch(error=>{
        console.log("loginAction error:")
        console.log(error)

        dispatch({
          type: STOP_LOADING
        })

        dispatch({
          type: LOGIN_FAIL
        })

      })

      return promise
  }
}

export function getUserInformationAction(data) {
  return function (dispatch) {
    dispatch({
      type: START_LOADING
    })
    
     let promise=  axios({
        method: "post",
        url: `${AppSettings.apiUrl}/api/User/GetUserInformation`,
        data: data
      })
      
      promise.then(response => {
        
        const success=response.data.success
        const user=response.data.user
        const employee=response.data.employee
        const role=employee?employee.role: "C"

        dispatch({
          type: STOP_LOADING
        })

        if (success) {
          Storage.setUser(user)
          Storage.setRole(role)
          Storage.setEmployeePIS(employee)
          Storage.setAppReadonly(response.data.readonly)
          Storage.setDatelocalStorage()
        }
      }
      ).catch(error=>{
        console.log("getUserInformationAction error:")
        console.log(error)

        dispatch({
          type: STOP_LOADING
        })

      })

      return promise
  }
}

export const logoutAction = () => {
  Storage.clear()

  return (dispatch) => {
    dispatch({
      type: LOGOUT
    });
  }
}

export function getADUserInfoAction(){
      let promise= axios({
        method: "get",
        url: `/user`,
        withCredentials : true
      })

      return promise
}

export function getUnitReviewerAction(unitCode) {
  return function (dispatch) {
    try {
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/User/GetUnit_Reviewer`,
        params: {
          unit_code: unitCode
        }
      })

      return promise
    } catch (error) {
    }
  }
}

export function getUserDataAction() {
  return function (dispatch) {
    try {
      let promise = axios({
        headers: authHeader(),
        method: "get",
        url: `${AppSettings.apiUrl}/api/UserCustom/GetAllEmp`
      })

      promise.then(response => {
        if (response.data.success) {
          dispatch({
            type: SET_USER_DATA,
            payload: response.data.response,
          });
        } else {
          dispatch({
            type: SET_USER_FAIL,
            payload: response.data.response,
          });
        }
      }
      );

      return promise
    } catch (error) {
    }
  }
}

// export function updateUserAction(data, index) {
//   return function (dispatch) {
//     dispatch({
//       type: UPDATE_USER_DATA,
//       data: data,
//       index: index
//     });
//   }
// }

export function updateUserModalAction(data) {
  return function (dispatch) {
    dispatch({
      type: UPDATE_USER_MODAL,
      data: data
    });
  }
}

export function createUserAction(data) {
  return function (dispatch) {
    try {
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/User/AddUser`,
        data: data
      })

      promise.then(response => {
        let isSuccess = response.data.isSuccess === true
        let returnMessage = response.data.returnMessage

        if (isSuccess) {
          dispatch({
            type: STOP_LOADING
          })
        } else {
          dispatch({
            type: SET_USER_FAIL,
            payload: returnMessage
          });
          dispatch({
            type: ERROR_USER_FAIL,
            payload: returnMessage
          });
        }

      }
      );

      return promise
    } catch (error) {
    }
  }
}

export function updateUserAction(data) {
  return function (dispatch) {
    try {
      let promise = axios({
        headers: authHeader(),
        method: "post",
        url: `${AppSettings.apiUrl}/api/User/UpdateUser`,
        data: data
      })

      promise.then(response => {
        let isSuccess = response.data.isSuccess === true
        if (isSuccess) {
          dispatch({
            type: STOP_LOADING
          })
        } else {
          dispatch({
            type: SET_USER_FAIL,
          });
        }
      }
      );

      return promise
    } catch (error) {
    }
  }
}

export function deleteUserAction(data) {
  return function (dispatch) {
    try {
      let promise = axios({
        headers: authHeader(),
        method: "delete",
        url: `${AppSettings.apiUrl}/api/UserCustom/${data}`
      })

      promise.then(response => {
        if (response.data.success) {
          dispatch({
            type: SET_USER_DATA,
            payload: response.data.response,
          });
        } else {
          dispatch({
            type: SET_USER_FAIL,
            data: response.data.response,
          });
        }
      }
      );

      return promise
    } catch (error) {
    }
  }
}

export function clearErrorMsgAction() {
  return function (dispatch) {
    dispatch({
      type: SET_USER_FAIL,
      data: ""
    });
  }
}

export function getAllUserAction(userDepartment) {
  return function (dispatch) {

    dispatch({
      type : START_LOADING
    })

    try {
      let promise = axios({
        headers: { ...authHeader(), 'Pragma': 'no-cache' },
        method: "get",
        url: `${AppSettings.apiUrl}/api/User/GetAllUser`,
        params: {
          userDepartment: userDepartment
        }
      })

      promise.then(response => {
       
        dispatch({
          type: GET_ALL_USER,
          payload: response.data,
        });

        dispatch({
          type: STOP_LOADING
        })
      }
      ).catch(error => {
        dispatch({
          type: STOP_LOADING
        })

        if (error.message && error.message.indexOf("code 401") != -1) {
          window.emitter.emit(ERROR_401)
        }
      })

      return promise
    } catch (error) {
    }
  }
}

